var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"up-btn",on:{"click":_vm.handelClick}},[_c('svg-icon',{staticClass:"up-btn__icon",attrs:{"name":_vm.like,"size":"19"}}),_c('span',{staticClass:"up-btn__font"},[_vm._v(_vm._s((" 点赞 " + _vm.number)))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }